import { Station } from '@app/core/types/stations';
import { useFragmentsDeliveryGetStationConfigConfig } from '@mi-front/api-v2';

/**
 * Whether external (fragments delivery) export is enabled for the station.
 * Uses the generated station-config hook so React Query dedupes with other consumers.
 */
export function useIsExternalExportEnabled(station: Station | undefined) {
  const query = useFragmentsDeliveryGetStationConfigConfig(station?.id ?? '', {
    query: { enabled: !!station?.id },
  });

  return query.data?.enabled;
}
